import React from 'react';
import { View, Text, ScrollView, Image } from 'react-native';

import Header from '../../components/Header';
import CardsCashback from '../../components/CardsCashback';

import styles from './styles';

const Cashback = () => {
    return (
        <>
            <Header />

            <View>
                <View style={styles.contentTitlePage}>
                    <Text style={styles.titlePage}>PROMOÇÕES</Text>
                </View>

                <CardsCashback />
            </View>
        </>
    );
}

export default Cashback;